import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

import { diamondGoToStep } from "areas/product/store/actions"
import { jewlr_t } from "helpers/application"

import { Tag } from "./components"

const ProgressBar = styled(Box)`
  border: none;
  height: 1px;
  left: 12.5%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: width 0.3s;
`
const Step = styled.div`
  cursor: pointer;
  position: relative;
  text-align: center;
  width: 25%;
`
const Circle = styled.div`
  background-color: ${(props) =>
    props.completed ? props.theme.colors.primary : props.theme.colors.white};
  border: 3px solid
    ${(props) =>
      props.selected || props.completed
        ? props.theme.colors.primary
        : props.theme.colors.grey[20]};
  border-radius: 50%;
  height: 24px;
  margin: 8px auto;
  position: relative;
  width: 24px;
  z-index: 1;
  :after {
    background-color: ${(props) => props.theme.colors.primary};
    border-radius: 50%;
    content: "";
    display: block;
    height: 12px;
    left: 50%;
    opacity: ${(props) => (props.selected ? 1 : 0)};
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s;
    width: 12px;
    z-index: 1;
  }
`

const StepTitle = styled(Typography).attrs({
  fontSize: 14,
})``

const progressWidth = {
  confirm_stone: "75%",
  d_clarity: "50%",
  d_color: "25%",
  d_cut: 0,
}

const InternalProgress = ({
  currentStepIndex,
  currentStepName,
  cutIndex,
  goToStep,
  selectedClarity,
  selectedColor,
  selectedCut,
}) => {
  return (
    <Flex mb={3} position="relative">
      <ProgressBar bg="grey.20" width="75%" />
      <ProgressBar bg="primary" width={progressWidth[currentStepName]} />
      <Step onClick={() => goToStep("d_cut", true)} selected>
        <Box height="18px">
          {currentStepIndex > cutIndex && <Tag> {selectedCut}</Tag>}
        </Box>

        <Circle
          completed={selectedCut && currentStepIndex > cutIndex}
          selected
        />
        <StepTitle>Cut</StepTitle>
      </Step>
      <Step
        onClick={() => goToStep("d_color", currentStepIndex > cutIndex + 1)}
        selected={currentStepIndex >= cutIndex + 1}
      >
        <Box height="18px">
          {currentStepIndex > cutIndex + 1 && <Tag> {selectedColor}</Tag>}
        </Box>

        <Circle
          completed={selectedColor && currentStepIndex > cutIndex + 1}
          selected={currentStepIndex >= cutIndex + 1}
        />
        <StepTitle>{jewlr_t("terms.Color")}</StepTitle>
      </Step>
      <Step
        onClick={() => goToStep("d_clarity", currentStepIndex > 4)}
        selected={currentStepIndex > cutIndex + 2}
      >
        <Box height="18px">
          {currentStepIndex > cutIndex + 2 && <Tag> {selectedClarity}</Tag>}
        </Box>
        <Circle
          completed={selectedClarity && currentStepIndex > cutIndex + 2}
          selected={currentStepIndex >= cutIndex + 2}
        />
        <StepTitle>Clarity</StepTitle>
      </Step>
      <Step
        onClick={() =>
          goToStep("confirm_stone", currentStepIndex > cutIndex + 3)
        }
        selected={currentStepIndex >= cutIndex + 3}
      >
        <Box height="18px">
          {currentStepIndex > cutIndex + 3 && <Tag> &nbsp;</Tag>}
        </Box>

        <Circle selected={currentStepIndex >= cutIndex + 3} />
        <StepTitle>Complete</StepTitle>
      </Step>
    </Flex>
  )
}

const mapStateToProps = (state) => {
  return {
    currentStepIndex: state.diamondUI.currentStep,
    currentStepName: state.diamondUI.steps[state.diamondUI.currentStep],
    cutIndex: state.diamondUI.steps.indexOf("d_cut"),
    selectedClarity: state.diamondUI.tmpDiamond.d_clarity,
    selectedColor: state.diamondUI.tmpDiamond.d_color,
    selectedCut: state.diamondUI.tmpDiamond.d_cut,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    goToStep: (step, value) => {
      if (value) {
        dispatch(diamondGoToStep(step))
      }
    },
  }
}

InternalProgress.propTypes = {
  currentStepIndex: PropTypes.number,
  currentStepName: PropTypes.string,
  cutIndex: PropTypes.number,
  goToStep: PropTypes.func,
  selectedClarity: PropTypes.string,
  selectedColor: PropTypes.string,
  selectedCut: PropTypes.string,
}

const Progress = connect(mapStateToProps, mapDispatchToProps)(InternalProgress)

export default Progress
